import { render, staticRenderFns } from "./Reg.vue?vue&type=template&id=647d2379"
import script from "./Reg.vue?vue&type=script&lang=js"
export * from "./Reg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports